import LanguageIcon from '@material-ui/icons/Language';
import DnsIcon from '@material-ui/icons/Dns';
import AndroidIcon from '@material-ui/icons/Android';
import SettingsIcon from '@material-ui/icons/Settings';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt';
import LayersIcon from '@material-ui/icons/Layers';
import type { SvgIconComponent } from '@material-ui/icons';
import { kindIconBg, kindIconColor } from '../theme';
import type { CreateKind } from '../types';

const ICONS: Record<CreateKind, SvgIconComponent> = {
  frontend: LanguageIcon,
  backend: DnsIcon,
  'ai-agent': AndroidIcon,
  worker: SettingsIcon,
  'scheduled-job': ScheduleIcon,
  fullstack: ViewQuiltIcon,
  compose: LayersIcon,
};

export function KindIcon({ kind, size = 48 }: { kind: CreateKind; size?: number }) {
  const Icon = ICONS[kind];
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 12,
        background: kindIconBg[kind],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon style={{ color: kindIconColor[kind], fontSize: size * 0.55 }} />
    </div>
  );
}
